import { z } from 'zod';

export const productDetailSchema = z.object({
  name: z.string().nonempty('Name is required')
});

export type ProductDetailFormValues = z.infer<typeof productDetailSchema>;
